<div>
    <div class="db-ecommerce-tax">
      <db-enable-tax-calc *ngIf="!calcTaxes" [website]="website"></db-enable-tax-calc>

      <ds-tabs *ngIf="!!calcTaxes"
               class="db-ecommerce-tax__tabs" [activeTabId]="activeTab" (onActiveTabChange)="setTabChange($event)" >
          <ds-tab-head [tabId]="'main'" [activeTabId]="activeTab">
              <span>{{ 'text_main' | dbText }}</span>
          </ds-tab-head>
          <ds-tab-head [tabId]="'settings'" [activeTabId]="activeTab">
              <span>{{ 'text_settings' | dbText }}</span>
          </ds-tab-head>
          <ds-tab-content>
              <div class="db-ecommerce-tax__content">
                  <ng-container *ngIf="activeTab === 'main'">
                      <db-ecommerce-tax-main [website]="website" [taxPlugin]="taxPlugin" [connectTaxesViaAdmin]="connectTaxes"></db-ecommerce-tax-main>
                  </ng-container>
                  <ng-container *ngIf="activeTab === 'settings'">
                      <db-ecommerce-tax-settings [website]="website" [taxPlugin]="taxPlugin"></db-ecommerce-tax-settings>
                  </ng-container>
              </div>
          </ds-tab-content>
        </ds-tabs>
    </div>
</div>
